import { render, staticRenderFns } from "./cpLink.vue?vue&type=template&id=0c6910a5&scoped=true&"
import script from "./cpLink.vue?vue&type=script&lang=js&"
export * from "./cpLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6910a5",
  null
  
)

export default component.exports